/** Ширина розмиття правого краю смуги (mask-image останніх 28px, як у прототипі). */
const FADE = 28;

/**
 * Тримає активну пігулку смуги груп видимою (прототип v4 keepActiveTopVisible, після кожного оновлення): якщо смуга прокручується, а пігулка
 * aria-current="page" заходить у розмиття правого краю — прокручує так, щоб її правий край вийшов із розмиття (прототип у цьому випадку
 * доходить до кінця смуги), за лівий край — щоб лівий край був за 8px від початку.
 */
export function keepActiveVisible(nav: HTMLElement | null): void {
  if (!nav || nav.scrollWidth <= nav.clientWidth + 1) return;
  const on = nav.querySelector<HTMLElement>('[aria-current="page"]');
  if (!on) return;
  const left = on.offsetLeft - nav.offsetLeft;
  const right = left + on.offsetWidth;
  if (left < nav.scrollLeft) nav.scrollLeft = Math.max(0, left - 8);
  else if (right > nav.scrollLeft + nav.clientWidth - FADE) nav.scrollLeft = right - nav.clientWidth + FADE;
}
